import React from 'react';
import { BookOpenIcon, ShoppingCartIcon, CalendarIcon, UtensilsIcon } from 'lucide-react';
const included = [{
  icon: BookOpenIcon,
  title: "60 Ricette pronte all'uso",
  desc: 'Dalla colazione alla cena, tutto strutturato per chi ha poco tempo e vuole il massimo gusto.'
}, {
  icon: ShoppingCartIcon,
  title: 'Lista della Spesa Tiroide-Friendly',
  desc: "Saprai esattamente cosa comprare all'Esselunga, Coop o Conad per nutrire la tua tiroide."
}, {
  icon: CalendarIcon,
  title: 'Mini Piano Settimanale da 15 Minuti',
  desc: 'Un menù completo per iniziare senza dover pensare "cosa cucino oggi?".'
}, {
  icon: UtensilsIcon,
  title: 'Abbinamenti e Idee di Contorno',
  desc: 'Suggerimenti veloci per rendere ogni pasto saziante e completo.'
}];
export function IncludedSection() {
  return <section className="py-8 px-4 bg-white" data-id="element-101">
      <div className="max-w-2xl mx-auto" data-id="element-102">
        <h2 className="text-xl sm:text-2xl font-heading font-bold text-brand-primary text-center mb-6" data-id="element-103">
          Tutto incluso nel Kit "Tiroide Felice"
        </h2>
        <p className="text-center text-brand-text mb-6 font-bold" data-id="element-104">
          Cosa otterrai oggi:
        </p>

        <div className="space-y-4" data-id="element-105">
          {included.map((item, i) => <div key={i} className="bg-brand-bg border border-brand-border rounded-lg p-5 flex gap-4 items-start" data-id="element-106">
              <div className="bg-brand-primary/10 p-3 rounded-lg shrink-0" data-id="element-107">
                <item.icon className="w-6 h-6 text-brand-primary" data-id="element-108" />
              </div>
              <div data-id="element-109">
                <h3 className="font-bold text-brand-primary text-base mb-1" data-id="element-110">
                  ⚡ {item.title}
                </h3>
                <p className="text-sm text-brand-text" data-id="element-111">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}